import { create } from 'zustand'
import { logger } from '@/utils/logger'

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  userInfo: {
    user_id: number
    nickname: string
    email: string | null
    is_agree: boolean
    provider: string
  } | null

  // Actions
  setAccessToken: (token: string | null) => void
  setRefreshToken: (token: string | null) => void
  setUserInfo: (userInfo: any) => void
  clearAuth: () => void

  // Getters
  getAccessToken: () => string | null
  getRefreshToken: () => string | null
  isAuthenticated: () => boolean
}

export const useAuthStore = create<AuthState>((set, get) => ({
  accessToken: null,
  refreshToken: null,
  userInfo: null,

  setAccessToken: token => {
    logger.token('Access Token 설정:', token ? '있음' : 'null')
    set({ accessToken: token })
  },

  setRefreshToken: token => {
    logger.token('Refresh Token 설정:', token ? '있음' : 'null')
    set({ refreshToken: token })
  },

  setUserInfo: userInfo => {
    logger.auth('사용자 정보 설정:', userInfo)
    set({ userInfo })
  },

  clearAuth: () => {
    logger.auth('인증 정보 초기화')
    set({ accessToken: null, refreshToken: null, userInfo: null })
  },

  getAccessToken: () => {
    return get().accessToken
  },

  getRefreshToken: () => {
    return get().refreshToken
  },

  isAuthenticated: () => {
    const token = get().accessToken
    return !!token
  }
}))
